<template>
  <div class="py-2 w-full">
    <label style="color: #C38437"
      class="block uppercase tracking-wide bg-transparent text-white text-black font-thin mb-2"
      :for="label"
      >{{ label }}</label
    >
    <input
      :id="label"
      class="appearance-none rounded-none relative bg-white block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
      @input="$emit('input', $event.target.value)"
      @change="this.onChange"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
export default {
  name: "BaseInput",
  props: {
    label: String,
  },
  methods: {
    onChange($event) {
      if ($event.target.files) {
        this.$emit("files", $event.target.files);
      }

      this.$emit("change", $event.target.value);
    },
  },
};
</script>
